import React, { useEffect } from "react";

function GoogleLoginButton({ onGoogleSuccess }) {

  useEffect(() => {
    function loadGoogle() {
      return new Promise((resolve) => {
        if (window.google) return resolve(window.google);

        const interval = setInterval(() => {
          if (window.google) {
            clearInterval(interval);
            resolve(window.google);
          }
        }, 50);
      });
    }

    loadGoogle().then((google) => {
      google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        callback: (response) => onGoogleSuccess(response.credential),
      });

      google.accounts.id.renderButton(
        document.getElementById("googleSignInBtn"),
        { theme: "filled_blue", size: "large" }
      );
    });
  }, [onGoogleSuccess]);

  return <div id="googleSignInBtn"></div>;
}

export default GoogleLoginButton;
